import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/spaces/$spaceId/carriers')({
  beforeLoad: ({ context, params }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['carriers:manage', 'carriers:access-read-only'])
    ) {
      throw redirect({ params: { spaceId: params.spaceId }, to: '/settings/spaces/$spaceId' });
    }
  },
  component: lazyRouteComponent(() =>
    import('&/features/settings/carriers/pages/carriers-page').then((m) => ({ default: m.CarriersPage })),
  ),
});
